import { filterUndefinedValue, stripObject } from '@/utils/object';
import { size_1_px_rem } from '@/const';
const helperProps = [
    'margin',
    'marginTop',
    'marginLeft',
    'marginRight',
    'marginBottom',
];
const innerProps = [
    'flexDirection',
    'flexWrap',
    // 'justifyContent',
    'alignContent',
    'alignItems',
    'display',
];
export const getMargin = (size, { isNegative, half } = { isNegative: false, half: false }) => {
    if (!size) {
        return {};
    }
    const attrs = ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'];
    const margins = {};
    const param = 1 * (isNegative ? -1 : 1) * (half ? 0.5 : 1);
    let value;
    attrs.forEach((attr, index) => {
        if (!Array.isArray(size)) {
            value = param * size;
        }
        else {
            switch (size.length) {
                case 1:
                    value = param * (size[0] || 0);
                    break;
                case 2:
                    value = param * (size[index] || size[index - 2] || 0);
                    break;
                case 3:
                    value =
                        param *
                            (index === 2 ? size[2] : size[index] || size[index - 2] || 0);
                    break;
                case 4:
                default:
                    value = param * (size[index] || 0);
                    break;
            }
        }
        margins[attr] = `calc(var(--m-s-base, ${size_1_px_rem}) * ${value})`;
    });
    return margins;
};
export const getSpacingHelperMargin = (spacing) => {
    return getMargin(spacing, { isNegative: true, half: true });
};
export const getChildMargin = (spacing) => {
    // @ts-ignore
    return getMargin(spacing, { half: true });
};
export const getPadding = (padding) => {
    if (!Array.isArray(padding)) {
        return {
            padding,
        };
    }
    const attrs = ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'];
    const paddings = {};
    let value;
    attrs.forEach((attr, index) => {
        switch (padding.length) {
            case 1:
                value = padding[0] || 0;
                break;
            case 2:
                value = padding[index] || padding[index - 2] || 0;
                break;
            case 3:
                value =
                    index === 2 ? padding[2] : padding[index] || padding[index - 2] || 0;
                break;
            case 4:
            default:
                value = padding[index] || 0;
                break;
        }
        paddings[attr] = `calc(var(--m-s-base, ${size_1_px_rem}) * ${value})`;
    });
    return paddings;
};
export const getGridGap = (gap) => {
    if (!Array.isArray(gap)) {
        return {
            gap,
        };
    }
    const attrs = ['rowGap', 'columnGap'];
    const gaps = {};
    gap.forEach((val, index) => {
        gaps[attrs[index]] = val;
    });
    return gaps;
};
export const filterHelperStyle = (style) => {
    const props = {};
    helperProps.forEach((key) => {
        props[key] = style[key];
    });
    return filterUndefinedValue({
        ...props,
        overflow: 'hidden',
    });
};
export const filterInnerStyle = (style) => {
    const props = {};
    innerProps.forEach((key) => {
        props[key] = style[key];
    });
    return filterUndefinedValue(props);
};
export const filterOuterStyle = (style) => {
    const props = {};
    [...innerProps].forEach((key) => {
        props[key] = style[key];
    });
    return filterUndefinedValue(stripObject(style, props));
};
export const getTemplateCount = (counts) => {
    if (!isNaN(counts) || typeof counts === 'string') {
        return `repeat(${counts}, minmax(0,1fr))`;
    }
    return counts;
};
export const getFlexs = (flex) => {
    if (!Array.isArray(flex)) {
        return {
            flex,
        };
    }
    const attrs = ['flexGrow', 'flexShrink', 'flexBasis'];
    const flexs = {};
    flex.forEach((val, index) => {
        flexs[attrs[index]] = val;
    });
    return flexs;
};
export const getBoxChildProps = (props) => {
    const { alignSelf, flex } = props;
    return filterUndefinedValue({
        alignSelf,
        ...getFlexs(flex),
    });
};
export const getGridChildProps = (props, device) => {
    const { row = 'initial', col = 'initial', rowSpan = 1, colSpan = 1,
    // justifySelf,
    // alignSelf,
     } = props;
    // let totalSpan = 12;
    let newColSpan = typeof colSpan === 'object' && 'desktop' in colSpan
        ? colSpan.desktop
        : colSpan;
    ['tablet', 'phone'].forEach((deviceKey) => {
        if (deviceKey === device) {
            if (typeof colSpan === 'object' && device in colSpan) {
                newColSpan = colSpan[device];
            }
            else {
                switch (deviceKey) {
                    case 'tablet':
                        // eslint-disable-next-line no-nested-ternary
                        newColSpan = colSpan > 5 ? 8 : colSpan > 2 ? 4 : 2;
                        break;
                    case 'phone':
                        newColSpan = colSpan > 2 ? 4 : 2;
                        break;
                }
            }
        }
    });
    return filterUndefinedValue({
        gridRowStart: row,
        gridRowEnd: `span ${rowSpan}`,
        gridColumnStart: col,
        gridColumnEnd: `span ${newColSpan}`,
    });
};
export const createStyle = ({ device, display, gap, direction, dense, rowSpan, colSpan, row, col, rows, columns, justify, 
// justifySelf,
align, alignSelf, wrap, flex, padding, margin, }) => {
    let style = {
        ...getPadding(padding),
    };
    let deviceColumns = 'auto';
    switch (device) {
        case 'phone':
            deviceColumns = 4;
            break;
        case 'tablet':
            deviceColumns = 8;
            break;
        case 'desktop':
            deviceColumns = 12;
            break;
        default:
            break;
    }
    const newColumns = !isNaN(columns) || typeof columns === 'string' ? columns : deviceColumns;
    switch (display) {
        case 'grid':
            style = {
                // parent
                ...getGridGap(gap),
                gridTemplateRows: getTemplateCount(rows),
                gridTemplateColumns: getTemplateCount(newColumns),
                gridAutoFlow: `${direction || ''}${dense && ' dense'}`,
                // justifyItems: justify,
                // alignItems: align,
                // child
                ...getGridChildProps({
                    row,
                    rowSpan,
                    col,
                    colSpan,
                    // justifySelf,
                    // alignSelf,
                }, device),
                ...style,
            };
            break;
        case 'flex':
            style = {
                // parent
                msFlexDirection: direction,
                flexDirection: direction,
                msFlexWrap: wrap ? 'wrap' : 'none',
                flexWrap: wrap ? 'wrap' : 'nowrap',
                msFlexPack: justify,
                justifyContent: justify,
                msFlexAlign: align,
                alignItems: align,
                ...getMargin(margin),
                // child
                ...getBoxChildProps({
                    alignSelf,
                    flex,
                }),
                ...style,
            };
            break;
        default:
            break;
    }
    // return prefix(style);
    return filterUndefinedValue(style);
};
